export default "__VITE_ASSET__ivQzfbQ7__"